// extracted by mini-css-extract-plugin
module.exports = {"userProfile":"UserProfile_userProfile__23BAx","userProfileName":"UserProfile_userProfileName__1krXM","userProfileLogoutButton":"UserProfile_userProfileLogoutButton__2nse0"};